import load from 'sdk/externalAccountAudit';
import { takeEvery } from 'redux-saga/effects';
import { LOAD } from 'model/exterrnalAccountAudit';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );
}
